import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AppRoutes } from '../paths';

// ----------------------------------------------------------------------

const LoginPage = lazy(() => import('../../pages/login-page'));
const AuthCallbackPage = lazy(() => import('../../pages/auth-callback-page'));

// ----------------------------------------------------------------------

export const publicRoutes = [
  {
    path: AppRoutes.LANDING_PAGE,
    element: (
      // TODO: implement nicer loading screen for fallback
      <Suspense fallback={<></>}>
        <Outlet />
      </Suspense>
    ),
    children: [
      {
        path: AppRoutes.LOGIN,
        element: <LoginPage />,
      },
      {
        path: AppRoutes.AUTH_CALLBACK,
        element: <AuthCallbackPage />,
      },
    ],
  },
];
